import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompanyOperatorUser, Currency } from '../models/company.model';
import { selectCurrencies, selectOperatorUsers } from './company.selectors';

@Injectable({ providedIn: 'root' })
export class CompanyReferenceDataSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly currencies: Signal<Currency[]> =
    this._store.selectSignal(selectCurrencies);
  public readonly operatorUsers: Signal<CompanyOperatorUser[]> =
    this._store.selectSignal(selectOperatorUsers);
}
